var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { title: _vm.modalTitle, size: "xl" },
    on: { close: _vm.handleClose },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c("ValidationObserver", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, errors, invalid }) {
                    return [
                      _vm.showStatusDropdown
                        ? _c("ValidationProvider", {
                            attrs: { rules: "required_field", name: "Status" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "FormGroup",
                                        {
                                          attrs: {
                                            title: "Status",
                                            errors: errors,
                                          },
                                        },
                                        [
                                          _c("CustomRequestStatusMultiselect", {
                                            attrs: {
                                              value: _vm.request.status,
                                              multiple: false,
                                            },
                                            on: {
                                              input: (val) =>
                                                (_vm.request.status = val),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "grid grid-cols-2 gap-8" },
                        [
                          _c("ValidationProvider", {
                            attrs: {
                              rules: "required_field",
                              name: "Job Title",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("FormGroup", {
                                        attrs: {
                                          errors: errors,
                                          title: "Job Title",
                                          name: "job_title",
                                          placeholder: "Enter job title",
                                        },
                                        model: {
                                          value: _vm.request.jobTitle,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.request,
                                              "jobTitle",
                                              $$v
                                            )
                                          },
                                          expression: "request.jobTitle",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("ValidationProvider", {
                            attrs: {
                              rules: "required_field",
                              name: "Number of contractors",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("FormGroup", {
                                        attrs: {
                                          errors: errors,
                                          title: "Number of contractors",
                                          name: "number_of_contractors",
                                          placeholder:
                                            "Enter number of contractors",
                                        },
                                        model: {
                                          value:
                                            _vm.request.number_of_contractors,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.request,
                                              "number_of_contractors",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "request.number_of_contractors",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "grid grid-cols-2 gap-8" },
                        [
                          _c(
                            "FormGroup",
                            { attrs: { title: "Skills" } },
                            [
                              _c("SkillsMultiselect", {
                                attrs: { limit: _vm.skillsMultiselectLimit },
                                model: {
                                  value: _vm.request.skills,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.request, "skills", $$v)
                                  },
                                  expression: "request.skills",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "grid grid-cols-2 gap-4" },
                            [
                              _c(
                                "FormGroup",
                                {
                                  attrs: {
                                    id: "title",
                                    title: "Minimum Budget",
                                    name: "Mininmum Budget",
                                    placeholder: " Minimum Budget",
                                  },
                                },
                                [
                                  _c("FormInputGroup", {
                                    attrs: {
                                      errors: errors,
                                      inputClasses: "pl-7",
                                      type: "text",
                                      prefix: "$",
                                    },
                                    model: {
                                      value: _vm.request.min_budget,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.request, "min_budget", $$v)
                                      },
                                      expression: "request.min_budget",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "FormGroup",
                                {
                                  attrs: {
                                    id: "title",
                                    title: "Maximum Budget",
                                    name: "Maximum Budget",
                                    placeholder: " Maximum Budget",
                                  },
                                },
                                [
                                  _c("FormInputGroup", {
                                    attrs: {
                                      errors: errors,
                                      inputClasses: "pl-7",
                                      type: "text",
                                      prefix: "$",
                                    },
                                    model: {
                                      value: _vm.request.max_budget,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.request, "max_budget", $$v)
                                      },
                                      expression: "request.max_budget",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "grid grid-cols-2 gap-8" },
                        [
                          _c(
                            "div",
                            { staticClass: "row-span-full" },
                            [
                              _c("p", { staticClass: "mb-2" }, [
                                _vm._v("Duration"),
                              ]),
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _c("p", { staticClass: "mt-2 mr-2" }, [
                                    _vm._v("from"),
                                  ]),
                                  _c("ValidationProvider", {
                                    attrs: {
                                      rules: "required_field",
                                      vid: "from_date",
                                      name: "From Date",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors, failed }) {
                                            return [
                                              _c(
                                                "FormGroup",
                                                {
                                                  attrs: {
                                                    errors: errors,
                                                    name: "From Date",
                                                  },
                                                },
                                                [
                                                  _c("FormDatepicker", {
                                                    attrs: {
                                                      calendarClass:
                                                        "bottom-11",
                                                      invalid: failed,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.request.from_date,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.request,
                                                          "from_date",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "request.from_date",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("p", { staticClass: "mt-2 ml-2 mr-2" }, [
                                    _vm._v("till"),
                                  ]),
                                  _c("ValidationProvider", {
                                    attrs: {
                                      rules:
                                        "noBeforeDate:@start_date,@ongoing|required_field",
                                      vid: "end_date",
                                      name: "Till Date",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors, failed }) {
                                            return [
                                              _c(
                                                "FormGroup",
                                                {
                                                  attrs: {
                                                    errors: errors,
                                                    name: "Till Date",
                                                  },
                                                },
                                                [
                                                  _c("FormDatepicker", {
                                                    attrs: {
                                                      calendarClass:
                                                        "right-0 bottom-11",
                                                      invalid: failed,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.request.to_date,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.request,
                                                          "to_date",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "request.to_date",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c("p", [_vm._v("Type")]),
                              _c("TagMultiselect", {
                                staticClass: "mb-8",
                                attrs: { selectedTagId: _vm.request.tag_id },
                                on: { input: _vm.setTagId },
                                model: {
                                  value: _vm.request.tag_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.request, "tag_id", $$v)
                                  },
                                  expression: "request.tag_id",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormGroup",
                            { attrs: { title: "Description" } },
                            [
                              _c("FormTextArea", {
                                attrs: {
                                  name: "description",
                                  placeholder: "Enter description",
                                  rows: 6,
                                },
                                model: {
                                  value: _vm.request.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.request, "description", $$v)
                                  },
                                  expression: "request.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "grid grid-cols-2" }),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c("UIButton", {
                            staticClass: "mr-4",
                            attrs: { variant: "outline", buttonText: "Cancel" },
                            on: { click: _vm.handleClose },
                          }),
                          _c("UIButton", {
                            attrs: {
                              disabled: invalid,
                              processing: _vm.processing,
                              buttonText: "Submit",
                            },
                            on: {
                              click: function ($event) {
                                return handleSubmit(_vm.onSubmit)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }